import {useEffect, useRef, useState} from "react";
import profilePhoto from "../../assets/profilephoto.jpg";
import {BTN_KEY} from "../../util/util";

import icnImg from "../../assets/icn.jpg";
import ssyyImg from "../../assets/ssyy.png";

const Others2 = ({changeBtnKey, setCanAllShow = () => {}, allMode = false}) => {
    console.log("setCanAllShow:", setCanAllShow);
    console.log("type:", typeof setCanAllShow);
    const stickerItemList = [
        {
            imagePath: profilePhoto,
        },
    ]

    const othersInfo = {
        initTitle : `정보 불러오는 중...`,
        successTitle : '불러오기 성공',
        // initTitle : `Loading ... `,
        // successTitle : `It's me`,
    }

    useEffect(() => {
        setTimeout(() => {
            if (initTitle === othersInfo.initTitle) {
                setInitTitle(othersInfo.successTitle);
                setCanAllShow(true);
            }
        }, 2000)
    }, []);

    const [initTitle, setInitTitle] = useState(othersInfo.initTitle);


    const commonStudyTitle = '🎓 교육 (Education)';
    const certificationTitle = '🪪 자격증 (Certifications)';
    const commonSkillsTitle= '🛠️ 기술 (Skills)';

    const studyList = [
        {
            img: ssyyImg,
            content:'"실무 프로젝트 기반 빅데이터 서비스 솔루션 개발자 양성과정 4기" Java 기반 풀스택 프로그래밍 과정',
            period:'2023.01 ~ 2023.08',
            server: '쌍용강북교육센터',
        },
        {
            img: icnImg,
            content:'Front-End 입문을 위한 HTML5 웹프로그래밍',
            period:'2022.12 ~ 2023.01',
            server: '인천대학교',
        }
    ]

    const certificationList = [
        {
            content:'토익스피킹 IH(150)',
            period:'2025.12',
        },
        {
            content:'정보처리기사',
            period:'2023.11',
        },
        {
            content:'파이썬 마스터 3급',
            period:'2023.09',
        },
        {
            content:'SQLD (SQL 개발자)',
            period:'2023.07',
        },
        {
            content:'산업안전산업기사',
            period:'2022.09',
        },
        {
            content:'워드프로세서',
            period:'2022.02',
        },
        {
            content:'운전면허 (1종 보통)',
            period:'2018.04',
        }
    ]

    const skillList = [
        {
            type: 'fe',
            name: 'React',
        },
        {
            type: 'fe',
            name: 'JS',
        },
        {
            type: 'be',
            name: 'JAVA',
        },
        {
            type: 'be',
            name: 'Spring',
        },
        {
            type: 'be',
            name: 'MyBatis',
        },
        {
            type: 'be',
            name: 'JPA',
        },
        {
            type: 'db',
            name: 'Oracle',
        },
        {
            type: 'db',
            name: 'MySQL',
        },
        {
            type: 'os',
            name: 'Windows',
        },
        {
            type: 'os',
            name: 'Linux',
        },
        {
            type: 'solution',
            name: 'AEM',
        },
        {
            type: 'solution',
            name: 'AWS',
        }
    ]

    const skillClassMapData = {
        fe: 'badge d-flex align-items-center p-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill',
        be: 'badge d-flex align-items-center p-1 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill',
        db: 'badge d-flex align-items-center p-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill',
        os: 'badge d-flex align-items-center p-1 pe-2 text-dark-emphasis bg-light-subtle border border-dark-subtle rounded-pill',
        solution: 'badge d-flex align-items-center p-1 pe-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill',
    }

    const activeTarget = 'choice-summary-3';
    const focusRef = useRef();
    useEffect(() => {
        if (allMode) return;
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[]);

    return (
        <>
            <div className='container' ref={focusRef}>
                <hr className='featurette-divider'/>
                {/*{!allMode && (*/}
                    <div className='right-align'>
                        <h4>
                            <div>
                                <div className="fs-2 mt-2 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35"
                                         fill="currentColor"
                                         className="bi bi-x-circle custom-fold-top" viewBox="0 0 16 16"
                                         onClick={() => {
                                             changeBtnKey(BTN_KEY.DEFAUlT);
                                         }}>
                                        <path
                                            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                                    </svg>
                                </div>
                            </div>
                        </h4>
                    </div>
                {/*)}*/}
                <div className={`${initTitle === othersInfo.successTitle? 'code-bg-complete' :'code-bg'} text-center border-bottom`}>
                    <h1 className={`${initTitle === othersInfo.successTitle? 'code-index-complete' :'code-index'} typing`}>
                        {initTitle}
                    </h1>
                </div>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        {stickerItemList.map((item, index) => (
                            <div className="col-12 col-md-10 col-lg-7 mb-4" key={`sticker-${index + 1}`}>
                                <div className="card border-0 shadow-sm h-100 profile-card-bs">
                                    <div className="row g-0 align-items-center">
                                        {/* 좌측 이미지 */}
                                        <div className="col-12 col-sm-4 text-center p-4">
                                            <div className="position-relative d-inline-block">
                                                <img
                                                    src={item.imagePath}
                                                    className="img-fluid rounded-circle profile-img-bs"
                                                    alt="profile"
                                                />
                                            </div>
                                        </div>
                                        {/* 우측 */}
                                        <div className="col-12 col-sm-8 p-4">
                                            {/* 이름 + 뱃지 */}
                                            <div
                                                className="d-flex align-items-center justify-content-between flex-wrap mb-3">
                                                <h5 className="fw-bold mb-1">{item.heading}</h5>
                                                <span className="badge bg-primary-subtle text-primary fw-semibold">
                                                  Full-stack
                                                </span>
                                            </div>
                                            {/* 코드 카드 */}
                                            <div className="bg-light rounded-3 p-1 border code-box-bs">
                                                <p className="mb-1">
                                                    <span className="text-primary fw-semibold">const</span>{" "}
                                                    <span className="text-info fw-bold">me</span> = {"{"}
                                                </p>
                                                {initTitle === othersInfo.successTitle && (
                                                    <>
                                                        <p className="mb-1"> name: "이준복",</p>
                                                        <p className="mb-1"> birth: "1996.07.16",</p>
                                                        <p className="mb-1"> university: "인천대학교 물리학과",</p>
                                                        <p className="mb-1"> email: "leejb0011@naver.com"</p>
                                                        {/*<p className="mb-1"> 이름: 이준복</p>*/}
                                                        {/*<p className="mb-1"> 생년월일: 1996.07.16</p>*/}
                                                        {/*<p className="mb-1"> 학력: 인천대학교(물리학과)</p>*/}
                                                        {/*<p className="mb-1"> 이메일: leejb0011@naver.com</p>*/}
                                                    </>
                                                )}
                                                <p className="mb-0">{"}"}</p>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {initTitle === othersInfo.successTitle && (
                  <>
                      {/* 교육 */}
                      <hr/>
                      <div className="col-lg-15 mb-5 mx-auto">
                          <h2>
                              {commonStudyTitle}
                          </h2>
                      </div>
                      <div className="custom-edu-card row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                          {studyList.map((item,index) =>
                              <div className="col" key={index+1}>
                                  <div className="card shadow-sm">
                                      <img
                                          src={item.img}
                                          alt="img"
                                          className="card-img-top"
                                          height="100%"
                                          width="100%"
                                      />
                                      <div className="card-body">
                                          <p className="card-text">[{item.server}]</p>
                                          <p className="card-text">{item.content}</p>
                                          <p className="card-text">{item.period}</p>
                                      </div>
                                  </div>
                              </div>
                          )}
                      </div>
                      <hr/>
                      {/*자격증*/}
                      <div className="col-lg-15 mx-auto">
                          <h2>
                              {certificationTitle}
                          </h2>
                          <div className='flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center'>
                              {certificationList.map((item, index) =>
                                  <div className="list-group list-group-checkable d-grid gap-2 border-0"
                                       key={`cert-${index + 1}`}>
                                      <label
                                          className="list-group-item rounded-3 py-3"
                                          htmlFor="listGroupCheckableRadios1">
                                          🚩 {item.content}
                                          <span className="d-block small opacity-50">
                                  {item.period}
                                </span>
                                      </label>
                                  </div>
                              )}
                          </div>
                      </div>
                      <hr/>
                      {/* 기술 */}
                      <div className="col-lg-15 mx-auto">
                          <h2>
                              {commonSkillsTitle}
                          </h2>
                          <div className='flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center'>
                              <div className="custom-skill-icon-group d-flex flex-wrap gap-2 justify-content-center">
                                  {skillList.map((item, index) =>
                                          <span
                                              key={`skill${index + 1}`}
                                              className={`custom-skill-icon d-flex align-items-center justify-content-center ${skillClassMapData?.[item.type] || ''}`}>
                                    {/*<img className="rounded-circle me-1" width="24" height="24"*/}
                                              {/*     src="https://github.com/mdo.png" alt=""/>*/}
                                              {item.name}
                                </span>
                                  )}
                              </div>
                          </div>
                      </div>
                  </>
                )}

            </div>
        </>
    )
}

export default Others2